export default "__VITE_ASSET__08077975__"